// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__3kTEM","card":"Info_card__362As","infected":"Info_infected__1lI0b","recovered":"Info_recovered__2_qgU","deaths":"Info_deaths__3yqER"};